// covered-by: frontends/carrie/src/ask-v2/services/__tests__/reviews.test.ts
import {
  getAskPunttReviewResponseSchema,
  type GetAskPunttReviewResponse,
} from "@mg/schemas/src/christo/askPunttReview";

import { API_URL } from "../../config/env";
import { smartFetch } from "../../utils/http";

const reviewsBase = `${API_URL}/private/catalyst/ask-puntt/reviews`;

export async function getAskPunttReview(
  reviewId: string,
): Promise<GetAskPunttReviewResponse> {
  const json = await smartFetch(`${reviewsBase}/${reviewId}`);
  return getAskPunttReviewResponseSchema.parse(json);
}
